import { useAuthStore } from '../store/authStore';

interface SubscriptionLimits {
  maxFavorites: number;
  showAds: boolean;
  tier: 'free' | 'pro';
}

const TIER_LIMITS: Record<string, SubscriptionLimits> = {
  free: { maxFavorites: 1, showAds: true, tier: 'free' },
  pro: { maxFavorites: 3, showAds: false, tier: 'pro' },
};

export function useSubscriptionLimits(): SubscriptionLimits {
  const user = useAuthStore((state) => state.user);
  const tier = user?.subscription || 'free';
  return TIER_LIMITS[tier] || TIER_LIMITS.free;
}
